
import './App.css';
import { Homepage } from './pages/homepage';

function App() {
  return (
    <Homepage/>
  );
}

export default App;
